import { z } from 'zod';

export const postCommentAiFeedbackSchema = z.object({
  actionItems: z.array(
    z.object({
      type: z.enum([
        'approval',
        'design_change_requested',
        'copy_change_requested',
        'reschedule_request',
        'other',
      ]),
      tasks: z.array(z.string()),
    })
  ),
});

export type PostCommentAiFeedbackSchema = z.infer<typeof postCommentAiFeedbackSchema>;

export type PostCommentReaction = {
  emoji: string;
  userId: string;
};

export const postCommentAuthorSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  image: z.string().nullable(),
});

export type PostCommentAuthorSchema = z.infer<typeof postCommentAuthorSchema>;

export const postCommentSchema = z.object({
  id: z.string(),
  content: z.string(),
  reactions: z.array(z.custom<PostCommentReaction>()).nullable(),
  externalId: z.string().nullable().optional(),
  userId: z.string().nullable().optional(),
  /**
   * Minimal author info embedded directly on the comment so consumers with
   * no other way to resolve `userId` into a name/avatar (e.g. an anonymous
   * client-area share-link visitor, who never fetches the agency's full
   * `/v1/users` list) can still render it. Optional/nullable for
   * backward compatibility with endpoints that don't populate it.
   */
  author: postCommentAuthorSchema.nullable().optional(),
  postId: z.string(),
  isClientVisible: z.boolean(),
  aiPromptId: z.string().nullable().optional(),
  aiFeedback: z.custom<PostCommentAiFeedbackSchema>().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type PostCommentSchema = z.infer<typeof postCommentSchema>;
